export enum IamAction {
    READ = 1,
    CREATE = 2,
    EDIT = 4,
    DELETE = 8,
    IMPORT = 16,
    EXPORT = 32,
    // APPROVE = 64,
    // REJECT = 128
}

export const IamActionLabels: Record<string, IamAction> = {
    'view': IamAction.READ,
    'create': IamAction.CREATE,
    'edit': IamAction.EDIT,
    'delete': IamAction.DELETE,
    'import': IamAction.IMPORT,
    'export': IamAction.EXPORT,
    // 'approve': IamAction.APPROVE,
    // 'reject': IamAction.REJECT,
};

export const IamActionValues: Record<keyof typeof IamAction, IamAction> = {
    READ: IamAction.READ,
    CREATE: IamAction.CREATE,
    EDIT: IamAction.EDIT,
    DELETE: IamAction.DELETE,
    IMPORT: IamAction.IMPORT,
    EXPORT: IamAction.EXPORT,
    // APPROVE: IamAction.APPROVE,
    // REJECT: IamAction.REJECT,
};

// export const IamActionLabels: Record<IamAction, string> = {
//   [IamAction.READ]: "READ",
//   [IamAction.CREATE]: "CREATE",
//   [IamAction.EDIT]: "EDIT",
//   [IamAction.DELETE]: "DELETE",
//   [IamAction.IMPORT]: "IMPORT",
//   [IamAction.EXPORT]: "EXPORT",
//   [IamAction.APPROVE]: "APPROVE",
//   [IamAction.REJECT]: "REJECT"
// };